module.exports = __webpack_public_path__ + "img/tribus-footer-logo@2x.6aab9ad1.png";